const TICK_MS = 1000;

function parseTarget(iso) {
  if (!iso || !String(iso).trim()) return null;
  const t = Date.parse(String(iso).trim());
  return Number.isNaN(t) ? null : t;
}

const SECONDS_PER_DAY = 86400;

function padTimePart(value, minDigits = 2) {
  const n = Math.max(0, Math.floor(value));
  const s = String(n);
  return s.length >= minDigits ? s : s.padStart(minDigits, '0');
}

function formatHms(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return `${padTimePart(h)}:${padTimePart(m)}:${padTimePart(sec)}`;
}

function formatRemain(diffSec, dayUnit) {
  const s = Math.max(0, Math.floor(diffSec));
  const unit = dayUnit || '天';
  if (s >= SECONDS_PER_DAY) {
    const days = Math.floor(s / SECONDS_PER_DAY);
    const rest = s % SECONDS_PER_DAY;
    return `${days}${unit} ${formatHms(rest)}`;
  }
  return formatHms(s);
}

function getSectionConfig(card) {
  const root = card.closest('time-sale-section');
  return {
    started: root?.dataset.countdownStartedLabel || '',
    dayUnit: root?.dataset.countdownDayUnit || '',
  };
}

function setCountdownMessage(timerRoot, message) {
  const messageEl = timerRoot.querySelector('[data-time-sale-countdown-message]');
  const digitsEl = timerRoot.querySelector('[data-time-sale-countdown-digits]');
  if (!messageEl || !digitsEl) return;

  if (message) {
    messageEl.textContent = message;
    messageEl.hidden = false;
    digitsEl.hidden = true;
  } else {
    messageEl.textContent = '';
    messageEl.hidden = true;
    digitsEl.hidden = false;
  }
}

function setActiveCountdownDigits(timerRoot, totalSeconds) {
  setCountdownMessage(timerRoot, '');

  const s = Math.max(0, Math.floor(totalSeconds));
  const days = Math.floor(s / SECONDS_PER_DAY);
  const hours = Math.floor((s % SECONDS_PER_DAY) / 3600);
  const minutes = Math.floor((s % 3600) / 60);
  const seconds = s % 60;

  const daysWrap = timerRoot.querySelector('.time-sale-card__countdown-segment--days');
  if (daysWrap) {
    daysWrap.hidden = s < SECONDS_PER_DAY;
  }

  const daysEl = timerRoot.querySelector('[data-countdown-part="days"]');
  const hoursEl = timerRoot.querySelector('[data-countdown-part="hours"]');
  const minutesEl = timerRoot.querySelector('[data-countdown-part="minutes"]');
  const secondsEl = timerRoot.querySelector('[data-countdown-part="seconds"]');

  if (daysEl) daysEl.textContent = String(days);
  if (hoursEl) hoursEl.textContent = padTimePart(hours);
  if (minutesEl) minutesEl.textContent = padTimePart(minutes);
  if (secondsEl) secondsEl.textContent = padTimePart(seconds);
}

function updatePreviewCountdownText(card, textEl) {
  const prefix = card.getAttribute('data-countdown-prefix') || '';
  const start = parseTarget(card.getAttribute('data-countdown-start'));
  const { started, dayUnit } = getSectionConfig(card);
  const now = Date.now();

  if (start && now >= start) {
    textEl.textContent = started || prefix;
    return;
  }
  if (start) {
    const diffSec = Math.floor((start - now) / 1000);
    const timeStr = formatRemain(diffSec, dayUnit);
    textEl.textContent = prefix ? `${prefix} ${timeStr}` : timeStr;
    return;
  }
  textEl.textContent = prefix;
}

function updateActiveCountdown(card, timerRoot) {
  const end = parseTarget(card.getAttribute('data-countdown-end'));
  const now = Date.now();

  if (!end) {
    setActiveCountdownDigits(timerRoot, 0);
    return;
  }
  const diffSec = Math.floor((end - now) / 1000);
  setActiveCountdownDigits(timerRoot, diffSec);
}

function updateCardCountdown(card) {
  const textEl = card.querySelector('[data-time-sale-countdown-text]');
  if (textEl) {
    updatePreviewCountdownText(card, textEl);
    return;
  }

  const timerRoot = card.querySelector('[data-time-sale-countdown]');
  if (!timerRoot) return;

  updateActiveCountdown(card, timerRoot);
}

function isCardCountdownSettled(card, now = Date.now()) {
  const isPreview = card.getAttribute('data-countdown-is-preview') === 'true';
  const start = parseTarget(card.getAttribute('data-countdown-start'));
  const end = parseTarget(card.getAttribute('data-countdown-end'));

  if (isPreview) {
    if (!start) return true;
    return now >= start;
  }
  if (!end) return true;
  return now > end;
}

function allCardsCountdownSettled(root) {
  const cards = root.querySelectorAll('[data-time-sale-card]');
  if (!cards.length) return true;
  const now = Date.now();
  return [...cards].every((card) => isCardCountdownSettled(card, now));
}

function tickSection(root) {
  root.querySelectorAll('[data-time-sale-card]').forEach(updateCardCountdown);
}

class TimeSaleSection extends HTMLElement {
  connectedCallback() {
    if (this.dataset.timeSaleInit === 'true') return;
    this.dataset.timeSaleInit = 'true';
    this.tick();
    this.timer = window.setInterval(() => this.tick(), TICK_MS);
  }

  disconnectedCallback() {
    this.#clearTimer();
  }

  #clearTimer() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  tick() {
    tickSection(this);
    if (allCardsCountdownSettled(this)) {
      this.#clearTimer();
    }
  }
}

function bindTabs(root) {
  const tabsHost = root.querySelector('section-tabs');
  if (!tabsHost) return;

  tabsHost.addEventListener('click', (event) => {
    const tabItem = event.target.closest('section-tab-item');
    if (!tabItem || !tabsHost.contains(tabItem)) return;
    window.requestAnimationFrame(() => tickSection(root));
  });
}

function bindTimeSaleQuickShop(root) {
  root.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-time-sale-quick-shop]');
    if (!trigger || !root.contains(trigger)) return;

    event.preventDefault();
    // 勿在此 stopPropagation：会先于 body 神策监听执行，导致 quick_buy_click 无法上报。
    // 阻止误触父级链接由按钮上的 data-stop_propagation 在神策回调里处理。

    const productUrl = trigger.getAttribute('data-product-url');
    if (!productUrl || typeof createProductModal !== 'function') return;

    const isPreview = trigger.getAttribute('data-is-preview') === 'true';
    createProductModal(productUrl, {
      purchaseType: isPreview ? 'only-buy' : 'add-buy',
    });
  });
}

function init() {
  document.querySelectorAll('time-sale-section').forEach((section) => {
    bindTabs(section);
    bindTimeSaleQuickShop(section);
  });
}

if (!customElements.get('time-sale-section')) {
  customElements.define('time-sale-section', TimeSaleSection);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
